import { render } from "./Beheer.vue?vue&type=template&id=152a0585&scoped=true&bindings={\"s_custom\":\"setup\",\"s_content\":\"setup\"}"
import script from "./Beheer.vue?vue&type=script&lang=js"
export * from "./Beheer.vue?vue&type=script&lang=js"

import "./Beheer.vue?vue&type=style&index=0&lang=css"
import "./Beheer.vue?vue&type=style&index=1&id=152a0585&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-152a0585"

export default script